import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { AuthService } from '../../../auth/auth.service';
import { Router } from '@angular/router';
import { permissions } from '../../../permissions';
import { SavedDataService } from '../services/saved-data.service';
import { ToastrService } from 'ngx-toastr';
import { MasterDataSelectionModalComponent } from '../master-data-selection-modal/master-data-selection-modal.component';
import { IMasterDataList } from '../interfaces/IMasterDataList';
import { MatDialog } from '@angular/material';
import { ConfirmationService } from 'primeng/api';
import { ExportModalComponent } from '../../../components/export-modal';
import { QuickOrderEditComponent } from './quick-order-edit/quick-order-edit.component';
import { MasterDataService } from '../services/master-data.service';
import { Title } from '@angular/platform-browser';
import {fiveDecCompanies} from '../../../../environments/environment';

@Component({
  templateUrl: './quick-order.component.html',
  styleUrls: ['./quick-order.component.scss'],
  providers: [AuthService, SavedDataService, MasterDataService],
})
export class QuickOrderComponent implements OnInit, AfterViewInit {
  private static charCodeTab = 9;
  private static charCodeNewLine = 10;
  private static charCodeCarriageReturn = 13;
  private static charCodeComma = 44;

  public permissions = permissions;
  public isWorkspaceSelected: boolean;
  public loading: boolean;
  public mode: string;
  public screenTitle: string;
  public permitAutoOrder: boolean;
  public confirmationDialogWidth: number;

  public poNumber: string;
  public jobNumber: string;
  public invoiceNumbers: string;
  public transferNumbers: string;
  public totalValue: number;

  @ViewChild('searchTextArea') searchTextArea: ElementRef;
  public searchBox: string;
  public searchBoxDisable: boolean;

  public colsSV: Array<any>;
  public totalSVRecords = 0;
  public rowsSV = [];
  private selectedSV = [];

  public colsIV: Array<any>;
  public totalIVRecords = 0;
  public rowsIV = [];
  private selectedIV = [];

  public parts: Array<any>;
  public savedDataServiceRef = SavedDataService;

  public quoteCheckbox = false;
  public canSeePrices: boolean;
  public summaryTotal = 0;

  constructor(
    private router: Router,
    private authService: AuthService,
    private savedDataService: SavedDataService,
    private masterDataService: MasterDataService,
    private toast: ToastrService,
    private elementRef: ElementRef,
    private dialog: MatDialog,
    private confirmationService: ConfirmationService,
    private title: Title
  ) {
    this.parseUrl(this.router.url);
    this.title.setTitle('OES - Quick Order');
  }

  ngOnInit() {
    this.isWorkspaceSelected = this.getSelectedWorkspace();
    this.loading = false;
    this.permitAutoOrder = false;
    this.confirmationDialogWidth = 425;

    this.totalValue = 0;
    this.poNumber = '';
    this.jobNumber = '';

    this.searchBox = '';
    this.searchBoxDisable = false;
    this.invoiceNumbers = '';
    this.transferNumbers = '';
    this.canSeePrices = this.authService.permissions.includes('VIEW_PRICING_INFO');

    this.parts = [];

    this.colsSV = [
      {
        field: 'CO1_ID',
        header: 'CO1_ID',
        visible: false,
        export: { visible: false, checked: false },
        width: 0,
      },
      {
        field: 'CU1_NAME',
        header: 'Customer',
        visible: false,
        export: { visible: true, checked: true },
        width: 0,
      },
      {
        field: 'PL1_SHORT_CODE',
        header: 'Plant Short Code',
        visible: false,
        export: { visible: true, checked: true },
        width: 0,
      },
      {
        field: 'PL1_NAME',
        header: 'Plant Name',
        visible: false,
        export: { visible: true, checked: true },
        width: 0,
      },
      {
        field: 'RA1_SHIP_TO_ID',
        header: 'Rack ID',
        visible: false,
        export: { visible: true, checked: true },
        width: 0,
      },
      {
        field: 'RA1_SHIP_TO_NAME',
        header: 'Rack Name',
        visible: false,
        export: { visible: true, checked: true },
        width: 0,
      },
      {
        field: 'CONTRACT_BIN_ID',
        header: 'Info',
        visible: true,
        export: { visible: false, checked: false },
        width: 90,
      },
      {
        field: 'CONTRACT_BIN_ID',
        header: 'Bin ID',
        visible: false,
        export: { visible: true, checked: true },
        width: 0,
      },
      {
        field: 'ITEM_ID',
        header: 'Item ID',
        visible: false,
        export: { visible: true, checked: true },
        width: 0,
      },
      {
        field: 'CUSTOMER_PART_NO',
        header: 'Customer Part No',
        visible: false,
        export: { visible: true, checked: true },
        width: 0,
      },
      {
        field: 'PO_NUMBER',
        header: 'PO Number',
        visible: true,
        export: { visible: true, checked: true },
        width: 35,
      },
      {
        field: 'JOB_NUMBER',
        header: 'Job Number',
        visible: true,
        export: { visible: true, checked: true },
        width: 35,
      },
      {
        field: 'DATE',
        header: 'Scan Date',
        visible: true,
        export: { visible: true, checked: true },
        width: 35,
      },
      {
        field: 'QUANTITY',
        header: 'Qty',
        visible: true,
        export: { visible: true, checked: true },
        width: 20,
      },
      {
        field: 'MD1_PRICE',
        header: 'Price',
        visible: this.canSeePrices,
        export: { visible: this.canSeePrices, checked: this.canSeePrices },
        width: 20,
      },
      {
        field: 'MD1_UM',
        header: 'UM',
        visible: true,
        export: { visible: true, checked: true },
        width: 20,
      },
      {
        field: 'TOTAL_PRICE',
        header: 'Ext. Value',
        visible: this.canSeePrices,
        export: { visible: this.canSeePrices, checked: this.canSeePrices },
        width: 35,
      },
    ];
    this.colsIV = [
      {
        field: 'CONTRACT_BIN_ID',
        header: 'Info',
        visible: true,
        export: { visible: true, checked: true },
        width: 90,
      },
      {
        field: 'PO_NUMBER',
        header: 'PO Number',
        visible: true,
        export: { visible: true, checked: true },
        width: 50,
      },
      {
        field: 'JOB_NUMBER',
        header: 'Job Number',
        visible: true,
        export: { visible: true, checked: true },
        width: 50,
      },
      {
        field: 'DATE',
        header: 'Scan Date',
        visible: true,
        export: { visible: true, checked: true },
        width: 50,
      },
    ];

    if (this.isWorkspaceSelected) {
      this.determineAutoOrderPermission();
      this.getData();
    }
  }

  ngAfterViewInit() {
    if (this.isWorkspaceSelected) {
      setTimeout(() => {
        this.searchTextArea.nativeElement.focus();
      }, 200);
    }
  }

  getSelectedWorkspace() {
    return this.authService.workspaceMasterCustomerID !== null;
  }

  private determineAutoOrderPermission() {
    this.savedDataService.preload().subscribe((preloadData) => {
      if (
        preloadData.hasOwnProperty('masterCustomer') &&
        preloadData.masterCustomer.hasOwnProperty(
          'CU0_ALLOW_INVENTORY_MANAGEMENT'
        )
      ) {
        this.permitAutoOrder =
          Number(preloadData.masterCustomer.CU0_ALLOW_INVENTORY_MANAGEMENT) ===
          1;
      }
    });
  }

  private parseUrl(url: string) {
    if (url === '/order-entry-system/' + this.savedDataServiceRef.SV2_URL) {
      this.screenTitle = this.savedDataServiceRef.SV2_TITLE;
      this.mode = this.savedDataServiceRef.MODE_SV2;
    } else if (
      url ===
      '/order-entry-system/' + this.savedDataServiceRef.SV3_URL
    ) {
      this.screenTitle = this.savedDataServiceRef.SV3_TITLE;
      this.mode = this.savedDataServiceRef.MODE_SV3;
    } else {
      this.screenTitle = this.savedDataServiceRef.SV1_TITLE;
      this.mode = this.savedDataServiceRef.MODE_SV1;
    }
  }

  getData() {
    this.loading = true;
    this.selectedSV = [];
    this.selectedIV = [];
    this.savedDataService.getItems(this.mode).subscribe(
      (result) => {
        this.rowsSV = result.valid.data;
        if (result.valid.data.length > 0) {
          this.summaryTotal = result.valid.data[0].CO1_ID;
        }
        this.totalSVRecords = result.valid.count;
        this.rowsIV = result.invalid.data;
        this.totalIVRecords = result.invalid.count;
        this.computeTotalValue();

        this.loading = false;
        this.searchBoxDisable = false;
        setTimeout(() => {
          this.searchTextArea.nativeElement.focus();
        }, 200);
      },
      () => {
        this.toast.error('Request timed out.', 'Service Error');

        this.loading = false;
        this.searchBoxDisable = false;
        setTimeout(() => {
          this.searchTextArea.nativeElement.focus();
        }, 200);
      }
    );
  }

  addItems() {
    this.searchBoxDisable = true;
    let startIndex = 0;
    const items = [];
    for (let i = 0; i < this.searchBox.length; i++) {
      const charCode = this.searchBox.charCodeAt(i);
      if (
        Number(charCode) === QuickOrderComponent.charCodeNewLine ||
        Number(charCode) === QuickOrderComponent.charCodeTab ||
        Number(charCode) === QuickOrderComponent.charCodeComma
      ) {
        if (i > startIndex) {
          const searchText = this.searchBox.substring(startIndex, i);
          if (searchText.trim().length > 0) {
            items.push({
              searchText: searchText.trim(),
              PO_NUMBER: this.poNumber,
              JOB_NUMBER: this.jobNumber,
            });
          }
        }
        startIndex = i + 1;
      } else if (i === this.searchBox.length - 1) {
        const searchText = this.searchBox.substring(startIndex, i + 1);
        if (searchText.trim().length > 0) {
          items.push({
            searchText: searchText.trim(),
            PO_NUMBER: this.poNumber,
            JOB_NUMBER: this.jobNumber,
          });
        }
      }
    }

    if (items.length > 0) {
      this.loading = true;
      if (items.length === 1) {
        this.showMatches(items[0]);
      } else {
        this.searchBox = '';
        this.createSavedData(items, true);
      }
    } else {
      this.searchBox = '';
      this.searchBoxDisable = false;
      setTimeout(() => {
        this.searchTextArea.nativeElement.focus();
      }, 200);
    }
  }

  autoOrder() {
    if (
      this.permitAutoOrder &&
      this.mode === this.savedDataServiceRef.MODE_SV1
    ) {
      const arr = [];
      arr.shift();
      this.loading = true;
      this.savedDataService.autoOrder(this.poNumber, this.jobNumber).subscribe(
        (result) => {
          if (result.success) {
            if (Number(result.linesAdded) > 0) {
              this.toast.success(
                'Added ' + Number(result.linesAdded) + ' lines via Auto Order.'
              );
              this.getData();
            } else {
              this.loading = false;
              this.toast.warning('No eligible lines via Auto Order.', '', {
                timeOut: 5000,
              });
            }
          } else {
            this.loading = false;
            this.toast.warning(
              'Unexpected error encountered in recording auto order items.'
            );
          }
        },
        () => {
          this.loading = false;
          this.toast.error('Request timed out.', 'Service Error');
        }
      );
    }
  }

  clearSearchBox() {
    this.searchBox = '';
    this.parts = [];
  }

  computeTotalValue() {
    this.totalValue = 0;
    this.rowsSV.forEach((row) => {
      this.totalValue += Number(row.TOTAL_PRICE);
    });
  }

  deleteSVLine(ID) {
    this.loading = true;
    this.savedDataService.delete([ID], this.mode).subscribe(
      (result) => {
        this.toast.success('Order updated', 'Success');
        this.getData();
      },
      () => {
        this.toast.error('Request timed out.', 'Service Error');
        this.getData();
      }
    );
  }

  deleteSVClick() {
    const IDs = this.rowsSV.map((savedData) => savedData.ID);
    this.confirmationDialogWidth = 425;
    this.confirmationService.confirm({
      header: 'Delete Order Lines',
      message: 'Are you sure to delete all order lines?',
      acceptLabel: 'Yes',
      accept: () => {
        this.loading = true;
        this.savedDataService.delete(IDs, this.mode).subscribe(
          (result) => {
            this.toast.success('Order updated', 'Success');
            this.getData();
          },
          (error) => {
            this.toast.error('Request timed out.', 'Service Error');
            this.getData();
          }
        );
      },
    });
  }

  deleteIVLine(ID) {
    this.loading = true;
    this.savedDataService.delete([ID], this.mode).subscribe(
      (result) => {
        this.toast.success('Invalid Scans updated', 'Success');
        this.getData();
      },
      () => {
        this.toast.error('Request timed out.', 'Service Error');
        this.getData();
      }
    );
  }

  deleteIVClick() {
    const IDs = this.rowsIV.map((savedData) => savedData.ID);
    this.confirmationDialogWidth = 425;
    this.confirmationService.confirm({
      header: 'Delete Invalid Scans',
      message: 'Are you sure to delete all invalid scans?',
      acceptLabel: 'Yes',
      accept: () => {
        this.loading = true;
        this.savedDataService.delete(IDs, this.mode).subscribe(
          (result) => {
            this.toast.success('Invalid scans cleared!', 'Success');
            this.getData();
          },
          (error) => {
            this.toast.error('Request timed out.', 'Service Error');
            this.getData();
          }
        );
      },
    });
  }

  editSVRow(index, invalidScan = false) {
    const dialogRef = this.dialog.open(QuickOrderEditComponent, {
      width: window.innerWidth - 100 + 'px',
      height: window.innerHeight - 120 + 'px',
      maxHeight: '600px',
      role: 'dialog',
      data: {
        scan: invalidScan ? this.rowsIV[index] : this.rowsSV[index],
        invalidScan: invalidScan,
      },
    });
    dialogRef.beforeClose().subscribe((editResult) => {
      if (editResult !== null) {
        this.loading = true;
        this.savedDataService
          .update(editResult, this.mode, invalidScan)
          .subscribe(
            (result) => {
              if (result.success) {
                this.getData();
              } else {
                this.toast.error('Could not update the line.', 'Error');
                this.loading = false;
              }
            },
            () => {
              this.toast.error('Request timed out.', 'Service Error', {
                timeOut: 3000,
                tapToDismiss: true,
              });
              this.getData();
            }
          );
      }
    });
  }

  exportSVClick() {
    if (this.rowsSV.length > 0) {
      const dialogRef = this.dialog.open(ExportModalComponent, {
        width: window.innerWidth - 100 + 'px',
        height: window.innerHeight - 80 + 'px',
        role: 'dialog',
        data: { cols: this.colsSV, modeEnabled: 0 },
      });

      dialogRef.beforeClose().subscribe((preferences) => {
        if (preferences) {
          this.loading = true;
          preferences['exportMode'] = preferences['mode'];
          preferences['mode'] = this.mode;
          this.savedDataService.export(preferences).subscribe(
            (result) => {
              this.savedDataService.generateXls(result, 'SavedData.xls');
              this.loading = false;
            },
            () => {
              this.toast.error('Error in exporting data.', 'Error', {
                timeOut: 3000,
                tapToDismiss: true,
              });
              this.loading = false;
            }
          );
        }
      });
    }
  }

  private getLoadedLinesSummaryString(valid: number, invalid: number): string {
    const lineCount = valid + invalid;
    let message = '';
    if (lineCount > 0) {
      message += lineCount + ' line' + (lineCount > 1 ? 's' : '');
      message +=
        ' (' +
        (valid > 0 ? valid + ' valid' : '') +
        (valid > 0 && invalid > 0 ? ', ' : '') +
        (invalid > 0 ? invalid + ' invalid' : '') +
        ')';
    } else {
      message += '0 lines';
    }
    return message;
  }

  private getDuplicateScansErrorString(duplicate: number): string {
    let message = '';
    if (duplicate > 0) {
      message +=
        'Duplicate barcode scanning is disabled (' +
        duplicate +
        ' duplicates added to Invalid scans).';
    }
    return message;
  }

  private printCreationResultToast(creationResult: any) {
    this.toast.info(
      this.getLoadedLinesSummaryString(
        creationResult.hasOwnProperty('valid')
          ? Number(creationResult['valid'])
          : 0,
        creationResult.hasOwnProperty('invalid')
          ? Number(creationResult['invalid'])
          : 0
      ) +
        ' recorded. ' +
        this.getDuplicateScansErrorString(
          creationResult.hasOwnProperty('duplicate')
            ? Number(creationResult['duplicate'])
            : 0
        ),
      'Update',
      {
        timeOut: 5000,
      }
    );
  }

  loadFromInvoice() {
    if (this.mode === this.savedDataServiceRef.MODE_SV3) {
      if (this.invoiceNumbers.trim().length > 0) {
        this.loading = true;
        this.savedDataService
          .loadFromInvoice(
            this.invoiceNumbers.trim(),
            this.poNumber,
            this.jobNumber,
            this.mode
          )
          .subscribe(
            (result) => {
              if (Number(result.valid) > 0 || Number(result.invalid) > 0) {
                this.invoiceNumbers = '';
                this.toast.success(
                  this.getLoadedLinesSummaryString(
                    Number(result.valid),
                    Number(result.invalid)
                  ) + ' loaded from Invoice#.',
                  'Success'
                );
                this.getData();
              } else {
                this.toast.warning('No data obtained for given Invoice#.');
              }
              this.loading = false;
            },
            () => {
              this.loading = false;
              this.toast.error('Request timed out.', 'Service Error');
            }
          );
      } else {
        this.toast.error('Invoice# is empty.', 'Error');
      }
    }
  }

  loadFromTransfer() {
    if (this.mode === this.savedDataServiceRef.MODE_SV3) {
      if (this.transferNumbers.trim().length > 0) {
        this.loading = true;
        this.savedDataService
          .loadFromTransfer(
            this.transferNumbers.trim(),
            this.poNumber,
            this.jobNumber,
            this.mode
          )
          .subscribe(
            (result) => {
              if (Number(result.valid) > 0 || Number(result.invalid) > 0) {
                this.transferNumbers = '';
                this.toast.success(
                  this.getLoadedLinesSummaryString(
                    Number(result.valid),
                    Number(result.invalid)
                  ) + ' loaded from Transfer#.',
                  'Success'
                );
                this.getData();
              } else {
                this.toast.warning('No data obtained for given Transfer#.');
              }
              this.loading = false;
            },
            () => {
              this.loading = false;
              this.toast.error('Request timed out.', 'Service Error');
            }
          );
      } else {
        this.toast.error('Transfer# is empty.', 'Error');
      }
    }
  }

  onChangeModel() {
    this.parts = [];
  }

  onOptionSelect(event) {
    const data = [
      {
        MD1_ID: event.option.value,
        PO_NUMBER: this.poNumber,
        JOB_NUMBER: this.jobNumber,
      },
    ];
    this.searchBoxDisable = true;
    this.searchBox = '';
    this.parts = [];
    this.createSavedData(data);
  }

  onTextAreaKeyDown(event) {
    const keyCode = Number(event.keyCode);
    if (keyCode === QuickOrderComponent.charCodeCarriageReturn) {
      setTimeout(() => {
        this.addItems();
      }, 500);
    } else if (keyCode === QuickOrderComponent.charCodeTab) {
      setTimeout(() => {
        this.searchBox += String.fromCharCode(QuickOrderComponent.charCodeTab);
        this.searchTextArea.nativeElement.focus();
      }, 150);
    }
  }

  openMasterData() {
    const dialogRef = this.dialog.open(MasterDataSelectionModalComponent, {
      width: window.innerWidth - 100 + 'px',
      height: window.innerHeight - 80 + 'px',
      role: 'dialog',
      data: { title: 'Master data', componentRef: this.elementRef },
    });

    dialogRef.beforeClose().subscribe((selected: IMasterDataList[]) => {
      if (selected.length > 0) {
        this.loading = true;
        const data = selected.map((item) => {
          return {
            MD1_ID: item.MD1_ID,
            PO_NUMBER: this.poNumber,
            JOB_NUMBER: this.jobNumber,
          };
        });
        this.createSavedData(data);
      }
    });
  }

  refreshClick() {
    this.getData();
  }

  onSubmit() {
    if (
      this.mode === this.savedDataServiceRef.MODE_SV1 &&
      this.rowsSV.length > 0
    ) {
      this.loading = true;
      const MD1_IDs = this.rowsSV.map((savedData) => savedData['MD1_ID']);

      // Task #36745799 - Autofill PO Number and Job Number or line items
      const poNumber = this.poNumber;
      const jobNumber = this.jobNumber;
      const savedDataService = this.savedDataService;
      const mode = this.mode;
      this.rowsSV.forEach(function (savedData) {
        if (!savedData['PO_NUMBER'] && !savedData['JOB_NUMBER']) {
          savedData['PO_NUMBER'] = poNumber;
          savedData['JOB_NUMBER'] = jobNumber;
          if (savedData !== null) {
            savedDataService
            .update(savedData, mode, false)
            .subscribe(
                (result) => {
                  if (result.success) {
                    console.log('Successful Update');
                  } else {
                    console.log('Error: Could not update the line.');
                  }
                },
                () => {
                  console.log('Service Error: Request timed out.');
                }
            );
          }
        }
      });

      this.savedDataService.checkRecentOrders(MD1_IDs).subscribe(
        (result) => {
          if (
            !result.hasOwnProperty('data') ||
            !result.hasOwnProperty('recentWindow')
          ) {
            this.loading = false;
            return;
          }

          const matchedMD1_IDs: Array<any> = result.data.map((MD1_ID) =>
            Number(MD1_ID)
          );
          if (matchedMD1_IDs.length > 0) {
            let message =
              'The following parts have been ordered recently (within the last ' +
              result.recentWindow +
              '). ' +
              'Are you sure you want to continue and place this order? <b>You may click NO to go back and edit the order</b>.' +
              '<br><br>' +
              '<ol>';
            let matchCount = 1;
            let extraCount = 0;
            for (const row of this.rowsSV) {
              if (matchedMD1_IDs.indexOf(Number(row['MD1_ID'])) > -1) {
                if (matchCount > 5) {
                  extraCount++;
                } else {
                  message +=
                    '<li>' +
                    'Contract Bin ID: ' +
                    row['CONTRACT_BIN_ID'] +
                    ', Item ID: ' +
                    row['ITEM_ID'] +
                    ', CPN: ' +
                    row['CUSTOMER_PART_NO'] +
                    '</li>';
                  matchCount++;
                }
              }
            }
            if (extraCount > 0) {
              message +=
                '</ol>' + '... and ' + extraCount.toString() + ' more lines.';
            }

            this.loading = false;
            this.confirmationDialogWidth = 600;
            this.confirmationService.confirm({
              header: 'Warning',
              message: message,
              acceptLabel: 'Yes, Submit Order',
              accept: () => {
                this.submitSavedData();
              },
            });
          } else {
            this.submitSavedData();
          }
        },
        () => {
          this.toast.error('Request timed out. Unexpected server error.');
        }
      );
    } else {
      this.submitSavedData();
    }
  }

  submitSavedData() {
    if (this.rowsSV.length > 0) {
      this.loading = false;
      const IDs = this.rowsSV.map((savedData) => savedData.ID);
      this.savedDataService
        .submit(IDs, this.mode, this.quoteCheckbox)
        .subscribe(
          (result) => {
            if (result.success) {
              this.toast.success(
                'Submitted ' + result.successCount + ' records!',
                'Success'
              );
              this.getData();
            } else {
              if (Number(result.successCount) > 0) {
                this.toast.info(
                  'Submitted ' + result.successCount + ' records.',
                  'Status'
                );
                this.getData();
              } else {
                this.toast.error(
                  'Unable to submit the records. Please try later.',
                  'Error'
                );
                this.loading = false;
              }
            }
          },
          () => {
            this.toast.error('Request timed out.', 'Service Error');
            this.loading = false;
          }
        );
    } else {
      this.toast.warning('You cannot submit an empty order.', 'Notice');
    }
  }

  validateIVClick() {
    this.loading = true;
    const data = this.rowsIV.map((item) => {
      return {
        searchText: item.CONTRACT_BIN_ID,
        ID: item.ID,
        PO_NUMBER: this.poNumber,
        JOB_NUMBER: this.jobNumber,
      };
    });
    this.createSavedData(data, true, true);
  }

  private showMatches(searchItem) {
    this.loading = true;
    this.savedDataService.showMatches(searchItem, this.mode).subscribe(
      (result) => {
        if (result.success) {
          if (result.data.length > 1) {
            // show result.data items
            this.searchBox = this.searchBox.trim();
            this.searchBoxDisable = false;
            setTimeout(() => {
              this.parts = result.data;
              this.searchTextArea.nativeElement.focus();
            }, 200);
          } else {
            this.printCreationResultToast(result.creationResult);
            this.searchBox = '';
            this.getData();
            this.searchBoxDisable = false;
          }
        } else {
          this.searchBoxDisable = false;
          this.toast.error('Error encountered in recording scans.', 'Error');
        }
        this.loading = false;
      },
      () => {
        this.loading = false;
        this.searchBoxDisable = false;
      }
    );
  }

  private createSavedData(data, validate = false, validateFromInvalid = false) {
    this.savedDataService.create(data, this.mode, validate).subscribe(
      (result) => {
        if (result.success) {
          if (validateFromInvalid) {
            if (
              result.creationResult.hasOwnProperty('valid') &&
              Number(result.creationResult['valid']) > 0
            ) {
              this.printCreationResultToast(result.creationResult);
            } else {
              this.toast.error(
                'Unable to validate any Invalid Scans.',
                'Error'
              );
            }
          } else {
            this.printCreationResultToast(result.creationResult);
          }
        } else {
          this.toast.error('Error encountered in recording scans.', 'Error');
        }
        this.getData();
      },
      () => {
        this.toast.error('Request timed out.', 'Service Error');
        this.loading = false;
        this.searchBoxDisable = false;
        setTimeout(() => {
          this.searchTextArea.nativeElement.focus();
        }, 200);
      }
    );
  }

    protected readonly fiveDecCompanies = fiveDecCompanies;
  protected readonly parseInt = parseInt;
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/oes/quick-order/quick-order.component.ts